import { ILangVocab, LanguageFlag } from '../app/i18n/interface';

//app vocabs
import { locale as EN_VOCABS } from '../app/i18n/vocabs/en';
import { locale as ES_VOCABS } from '../app/i18n/vocabs/es';

//angular internal locales
import { registerLocaleData } from '@angular/common';
import locale_en from '@angular/common/locales/en';
import locale_es from '@angular/common/locales/es';

//plugins
//flatpickr
import { DateHelperConfig } from '@shared/utils/tools/date-tools';
// import flatpickr from 'flatpickr';
// import { Catalan } from 'flatpickr/dist/l10n/cat';
// import { english } from 'flatpickr/dist/l10n/default';
// import { Spanish } from 'flatpickr/dist/l10n/es';
//date-fns
import { enUS, es } from 'date-fns/locale';

/**
 * This global constant allows you to configure which of the vocabs defined in i18n module will we load in our default translator.
 *
 * @author Carlos Duardo <charlieandroid55@gmail.com>
 */
export const I18N_AVAILABLE_VOCABS: ILangVocab[] = [ES_VOCABS, EN_VOCABS];

/**
 * This global constant allows you to configure which languages appear in the app's language selector.
 *
 * @author Carlos Duardo <charlieandroid55@gmail.com>
 */
export const AVAILABLE_LANGUAGES: LanguageFlag[] = [
  {
    lang: 'es',
    name: 'Español',
    flag: 'media/flags/spain.svg',
  },
  {
    lang: 'en',
    name: 'English',
    flag: 'media/flags/united-states.svg',
  },
];

/**
 * Idioma por defecto del BackOffice (IBSOA: español). Fuente única del default
 * usada por `LocaleService` y para validar el idioma guardado en localStorage.
 */
export const DEFAULT_LANGUAGE = 'es';

/**
 * Selector de idioma en la UI. Se mantiene el i18n (es/en) pero el menú de la
 * barra principal queda OCULTO: no se ofrece cambiar de idioma. Reactivar es
 * poner este flag en `true`.
 */
export const LANGUAGE_PICKER_ENABLED = false;

/**
 * This function is responsible for initializing plugins based on the selected locale. It takes in a localeID parameter
 * and uses a switch statement to determine which locale-specific plugins to register.
 * @param localeID
 *
 * @author Carlos Duardo <charlieandroid55@gmail.com>
 */
export function onLocaleChangeInitPlugins(localeID: string): void {
  switch (localeID) {
    case 'en':
      registerLocaleData(locale_en, 'en');
      DateHelperConfig.locale = enUS;
      // flatpickr.localize(english);
      break;
    case 'es':
    default:
      registerLocaleData(locale_es, 'es');
      DateHelperConfig.locale = es;
      // flatpickr.localize(Spanish);
      break;
  }
}
